import React from "react";
import { Descriptions, Tag, theme } from "antd";

interface BankAccountProps {
  data?: {
    accountName?: string;
    bankName?: string;
    shortCode?: string;
    accountNumber?: string;
    iban?: string;
    bik?: string;
  };
}

const BankAccount: React.FC<BankAccountProps> = ({ data }) => {
  const { token } = theme.useToken();

  return (
    <div
      style={{
        background: token.colorBgContainer,
        borderRadius: token.borderRadiusLG,
        padding: "16px 20px",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          paddingBottom: 12,
          marginBottom: 14,
          borderBottom: `1px solid ${token.colorBorderSecondary}`,
        }}
      >
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span
              style={{
                fontSize: 14,
                fontWeight: 600,
                color: token.colorTextHeading,
              }}
            >
              Primary Bank Account
            </span>
            <Tag color="blue" style={{ borderRadius: 4, margin: 0 }}>
              Primary
            </Tag>
          </div>
          <div
            style={{
              fontSize: 11,
              color: token.colorTextSecondary,
              marginTop: 1,
            }}
          >
            Default bank account displayed on practice invoices and payment
            receipts.
          </div>
        </div>
      </div>

      <Descriptions
        size="small"
        bordered={false}
        column={{ xs: 1, sm: 2, md: 3 }}
        labelStyle={{
          color: token.colorTextSecondary,
          fontWeight: 500,
          fontSize: 12,
        }}
        contentStyle={{
          color: token.colorText,
          fontWeight: 500,
          fontSize: 13,
        }}
      >
        <Descriptions.Item label="Account Name">
          {data?.accountName || "—"}
        </Descriptions.Item>

        <Descriptions.Item label="Bank Name">
          {data?.bankName || "—"}
        </Descriptions.Item>

        <Descriptions.Item label="Sort Code">
          {data?.shortCode ? (
            <Tag color="geekblue" style={{ borderRadius: 4, margin: 0 }}>
              {data.shortCode}
            </Tag>
          ) : (
            "—"
          )}
        </Descriptions.Item>

        <Descriptions.Item label="Account Number">
          {data?.accountNumber ? (
            <Tag color="blue" style={{ borderRadius: 4, margin: 0 }}>
              {data.accountNumber}
            </Tag>
          ) : (
            "—"
          )}
        </Descriptions.Item>

        <Descriptions.Item label="IBAN">{data?.iban || "—"}</Descriptions.Item>

        <Descriptions.Item label="BIC / Swift">
          {data?.bik || "—"}
        </Descriptions.Item>
      </Descriptions>
    </div>
  );
};

export default BankAccount;
